const externalRoutesPrefixList = ['/tezaury', '/ezbierky', '/elegislativa',
  '/pripomienky', '/sudne-rozhodnutia', '/sprava-vyjadreni', '/vestniky'];

export { externalRoutesPrefixList };
